/**
 * Returns the width of the active progress bar.
 *
 * @param steps - The number of steps to show in the progress bar.
 * @param activeStep - The active step.
 * @param stepProgress - The progress in the active step.
 * @returns The width in percent.
 */
export function calculateActiveBarWidth(
  steps: number,
  activeStep: number,
  stepProgress: number
): number {
  const stepWidth = Math.round(100 * (100 / (steps - 1))) / 100;

  // The width of the progress bar until the active step is reached
  let activeBarWidth = 0;
  if (activeStep > 0) {
    activeBarWidth = stepWidth * (Math.min(steps, activeStep) - 1);
  }

  // The width of the progress bar after the active step
  let progressWidth = 0;
  if (activeStep > 0 && activeStep < steps) {
    progressWidth = (stepWidth * stepProgress) / 100;
  }

  return activeBarWidth + progressWidth;
}
